import React, {MouseEvent, ReactNode} from "react";

import {useThemeDefaults} from "../../hooks/use_theme_defaults";
import {IComparisonTableStyleDefaults} from "../../types/IComparisonTableStyleDefaults";
import {RowHeaderIconWrap} from "./RowHeaderIcon";
import {RowHeaderTitle} from "./RowHeaderTitle";

interface IRendererProps {
    themeDefaults: IComparisonTableStyleDefaults;
}

interface IProps {
    iconSlot?: (props: IRendererProps) => ReactNode;
    iconShowOnMobile?: boolean;
    labelSlot: (props: IRendererProps) => ReactNode;
    onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
    className?: string;
}

export const RowHeaderCustom = (props: IProps) => {
    const themeDefaults = useThemeDefaults();
    const {iconSlot, iconShowOnMobile, labelSlot, onClick, className} = props;

    return (
        <div className={className} onClick={onClick}>
            {iconSlot && (
                <RowHeaderIconWrap iconSize={themeDefaults.headerIcons.size} showOnMobile={iconShowOnMobile}>
                    {iconSlot({themeDefaults})}
                </RowHeaderIconWrap>
            )}
            <RowHeaderTitle>{labelSlot({themeDefaults})}</RowHeaderTitle>
        </div>
    );
};
import React, {MouseEvent, ReactNode} from "react";

import {useThemeDefaults} from "../../hooks/use_theme_defaults";
import {IComparisonTableStyleDefaults} from "../../types/IComparisonTableStyleDefaults";
import {RowHeaderIconWrap} from "./RowHeaderIcon";
import {RowHeaderTitle} from "./RowHeaderTitle";

interface IRendererProps {
    themeDefaults: IComparisonTableStyleDefaults;
}

interface IProps {
    iconSlot?: (props: IRendererProps) => ReactNode;
    iconShowOnMobile?: boolean;
    labelSlot: (props: IRendererProps) => ReactNode;
    onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
    className?: string;
}

export const RowHeaderCustom = (props: IProps) => {
    const themeDefaults = useThemeDefaults();
    const {iconSlot, iconShowOnMobile, labelSlot, onClick, className} = props;

    return (
        <div className={className} onClick={onClick}>
            {iconSlot && (
                <RowHeaderIconWrap iconSize={themeDefaults.headerIcons.size} showOnMobile={iconShowOnMobile}>
                    {iconSlot({themeDefaults})}
                </RowHeaderIconWrap>
            )}
            <RowHeaderTitle>{labelSlot({themeDefaults})}</RowHeaderTitle>
        </div>
    );
};
